import React, { useState, useEffect, useRef } from "react";
import "./banner.css";
import Yellow from "../../../assets/images/logonext.png";
import red from "../../../assets/images/logonext.png";
import blue from "../../../assets/images/logonext.png";
import indigo from "../../../assets/images/logonext.png";
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";
import Chat from "../../../assets/images/chat.png";
import LiquidSwipe from "react-liquidswipe";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Component = (props) => {
  const scrollRef = useRef(null);
  const waveRef = useRef(null);
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scrollRef.current,
        scrub: 1,
      },
    });
    tl.to(waveRef.current, { y: 100 });
  }, []);
  const [move1, setmove1] = useState();
  const [move2, setmove2] = useState();
  return (
    <div ref={scrollRef} className="slidelayer_parent">
      <div ref={waveRef} className="wave"></div>
      <div className="slidelayer_parent2">
        <div className="kiyapata">
          <h6>Thessalonians 2:1-2</h6>
          <p>
            Now we beseech You, brethren, by the coming of our Lord Jesus
            <br />
            Cheist, And by our gathering together upto him, that ye be not soon
            <br />
            shaken in mind, or be troubied, neither by sprit, nor by letter as
            <br />
            from us, as that the day of christ is at hand
          </p>
          <button style={{ color: props.color }}>Discover</button>
        </div>
        <div
          className="hover_left"
          onMouseEnter={() => {
            setmove1(true);
          }}
          onMouseLeave={() => {
            setmove1(false);
          }}
        >
          <div className="bottom_detail">
            <h2 className={move1 == true ? "upndd" : "d_none"}>
              {props.headOne}
            </h2>
            <h3 className={move1 == true ? "upndd2" : "d_none"}>
              {props.priceOne}
            </h3>
            <div>
              <div
                className={
                  move1 == true
                    ? "upndd3 bottom_detail_para_right"
                    : "bottom_detail_para_right d_none "
                }
              >
                <p>{props.paraOne}</p>
              </div>
            </div>
            <div
              className={
                move1 == true
                  ? "upndd4 bottom_detail_buttons"
                  : "bottom_detail_buttons d_none "
              }
            >
              <button style={{ color: props.color }}>Go To Detail</button>
              <button>Add to Shopping Bag</button>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: props.color }} className="contentStyle1">
          <h1 className="market_place">M</h1>
          <h1 className="market_place market_place2">a</h1>
          <h1 className="market_place">r</h1>
          <h1 className="market_place market_place2">k</h1>
          <h1 className="market_place">e</h1>
          <h1 className="market_place market_place2">t</h1>
          <h1 className="market_place">p</h1>
          <h1 className="market_place market_place2">l</h1>
          <h1 className="market_place">a</h1>
          <h1 className="market_place market_place2">c</h1>
          <h1 className="market_place">e</h1>
        </div>
        <div
          className="hover_right"
          onMouseEnter={() => {
            setmove2(true);
          }}
          onMouseLeave={() => {
            setmove2(false);
          }}
        >
          <div className="bottom_detail">
            <h2 className={move2 == true ? "upndd" : "d_none"}>
              {props.headTwo}
            </h2>
            <h3 className={move2 == true ? "upndd2" : "d_none"}>
              {props.priceTwo}
            </h3>
            <div>
              <div
                className={
                  move2 == true
                    ? "upndd3 bottom_detail_para_right"
                    : "bottom_detail_para_right d_none "
                }
              >
                <p>{props.paraTwo}</p>
              </div>
            </div>
            <div
              className={
                move2 == true
                  ? "upndd4 bottom_detail_buttons"
                  : "bottom_detail_buttons d_none "
              }
            >
              <button style={{ color: props.color }}>Go To Detail</button>
              <button>Add to Shopping Bag</button>
            </div>
          </div>
        </div>
        <div className="top_layer_image">
          <img
            style={{
              transform:
                move1 == true
                  ? "translateX(0px)"
                  : "translateX(-400px)" && move1 == false
                  ? "translateX(-800px)"
                  : "translateX(-400px)" && move1 == null
                  ? "translateX(-400px)"
                  : "translateX(-400px)",
            }}
            src={blue}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

function Banner(props) {
  const para =
    "The supermarket typically has places for fresh meat, fresh produce, dairy, deli items, baked goods, etc. Shelf space is also reserved for canned and packaged goods and for various non-food items such as kitchenware, household cleaners, pharmacy products and pet supplies.";
  let components = [];
  components.push(
    <>
      <Component
        paraOne={para}
        paraTwo={para}
        headOne="SUPER MARKET"
        headTwo="SUPER MARKET"
        priceOne="$34.90"
        priceTwo="$34.90"
        color="#f8c024"
        {...props}
      />
    </>
  );
  components.push(
    <>
      <Component
        paraOne={para}
        paraTwo={para}
        headOne="SUPER MARKET"
        headTwo="SUPER MARKET"
        priceOne="$34.90"
        priceTwo="$34.90"
        color="#81d5e0"
        {...props}
      />
    </>
  );

  components.push(
    <>
      <Component
        paraOne={para}
        paraTwo={para}
        headOne="SUPER MARKET"
        headTwo="SUPER MARKET"
        priceOne="$34.90"
        priceTwo="$34.90"
        color="#f27671"
        {...props}
      />
    </>
  );

  components.push(
    <>
      <Component
        paraOne={para}
        paraTwo={para}
        headOne="SUPER MARKET"
        headTwo="SUPER MARKET"
        priceOne="$34.90"
        priceTwo="$34.90"
        color="#a465b6"
        {...props}
      />
    </>
  );
  return (
    <>
      <div className="main_banner">
        <div className="chat_mode">
          <img src={Chat} alt="" />
        </div>
        <LiquidSwipe components={components} />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  ThemeReducer: state.ThemeReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getTheme: (theme) => dispatch(getTheme(theme)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Banner);
